import type { AnchorHTMLAttributes, ReactNode } from "react"

type AstroTransitionLinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  children?: ReactNode
  to: string
  transitionName?: string
}

export function AstroTransitionLink({ children, to, transitionName, ...props }: AstroTransitionLinkProps) {
  return (
    <a
      {...props}
      href={to}
      data-view-transition-link="true"
      data-content-transition-name={transitionName}
      data-news-transition-name={transitionName}
    >
      {children}
    </a>
  )
}

export default AstroTransitionLink
